// ROCKSTAR - Polygon Coordinates
// Contains all polygon coordinates for highlighting found rockstars
// Each rockstar has an array of x,y coordinates that define the clickable/highlightable area

const polygonCoordinates = {
    "Roger Daltrey": [
        { x: 584, y: 298 },
        { x: 553, y: 298 },
        { x: 534, y: 237 },
        { x: 463, y: 222 },
        { x: 532, y: 11 },
        { x: 563, y: 10 },
        { x: 612, y: 133 },
    ],
    "Elton John": [
        { x: 456, y: 452 },
        { x: 494, y: 296 },
        { x: 473, y: 249 },
        { x: 417, y: 239 },
        { x: 379, y: 307 },
        { x: 379, y: 371 },
        { x: 392, y: 451 },
    ],
    "Pete Townshend": [
        { x: 527, y: 244 },
        { x: 550, y: 304 },
        { x: 598, y: 356 },
        { x: 612, y: 463 },
        { x: 563, y: 462 },
        { x: 536, y: 422 },
        { x: 495, y: 483 },
        { x: 457, y: 477 },
        { x: 504, y: 254 },
    ],
    "Mick Jagger": [
        { x: 607, y: 238 },
        { x: 594, y: 303 },
        { x: 623, y: 484 },
        { x: 651, y: 484 },
        { x: 680, y: 444 },
        { x: 670, y: 259 },
    ],
    "Jimmi Hendrix": [
        { x: 106, y: 589 },
        { x: 108, y: 503 },
        { x: 73, y: 439 },
        { x: -8, y: 444 },
        { x: 20, y: 513 },
        { x: 16, y: 585 },
    ],
    "Duane Allman": [
        { x: 146, y: 451 },
        { x: 115, y: 530 },
        { x: 115, y: 602 },
        { x: 138, y: 682 },
        { x: 207, y: 688 },
        { x: 210, y: 534 },
        { x: 240, y: 480 },
        { x: 219, y: 455 },
    ],
    "Roger Waters": [
        { x: 340, y: 552 },
        { x: 297, y: 583 },
        { x: 287, y: 727 },
        { x: 202, y: 725 },
        { x: 214, y: 689 },
        { x: 213, y: 593 },
        { x: 236, y: 508 },
        { x: 260, y: 508 },
        { x: 288, y: 558 },
        { x: 326, y: 542 },
    ],
    "Janis Joplin": [
        { x: 269, y: 506 },
        { x: 268, y: 442 },
        { x: 317, y: 442 },
        { x: 475, y: 501 },
        { x: 475, y: 529 },
        { x: 338, y: 542 },
        { x: 293, y: 531 },
    ],
    "George Harrison": [
        { x: 312, y: 578 },
        { x: 360, y: 546 },
        { x: 436, y: 542 },
        { x: 415, y: 606 },
        { x: 420, y: 669 },
        { x: 302, y: 673 },
    ],
    "Lou Reed": [
        { x: 481, y: 532 },
        { x: 480, y: 506 },
        { x: 538, y: 440 },
        { x: 559, y: 468 },
        { x: 621, y: 497 },
        { x: 622, y: 523 },
        { x: 569, y: 548 },
        { x: 557, y: 663 },
        { x: 514, y: 665 },
    ],
    "Bob Dylan": [
        { x: 684, y: 456 },
        { x: 634, y: 517 },
        { x: 670, y: 669 },
        { x: 749, y: 667 },
        { x: 730, y: 553 },
        { x: 796, y: 487 },
        { x: 781, y: 467 },
    ],
    "Freddie Mercury": [
        { x: 754, y: 632 },
        { x: 742, y: 555 },
        { x: 789, y: 495 },
        { x: 813, y: 444 },
        { x: 828, y: 365 },
        { x: 871, y: 452 },
        { x: 881, y: 500 },
        { x: 838, y: 553 },
        { x: 849, y: 616 },
        { x: 796, y: 616 },
    ],
    "Neil Young": [
        { x: 849, y: 667 },
        { x: 855, y: 617 },
        { x: 846, y: 567 },
        { x: 900, y: 487 },
        { x: 930, y: 487 },
        { x: 968, y: 541 },
        { x: 977, y: 567 },
        { x: 956, y: 670 },
    ],
    "Angus Young": [
        { x: 978, y: 564 },
        { x: 960, y: 523 },
        { x: 964, y: 479 },
        { x: 1017, y: 436 },
        { x: 1056, y: 460 },
        { x: 1092, y: 521 },
        { x: 1056, y: 586 },
        { x: 1016, y: 585 },
        { x: 1014, y: 624 },
        { x: 969, y: 617 },
    ],
    "Robert Plant": [
        { x: 431, y: 808 },
        { x: 424, y: 606 },
        { x: 480, y: 566 },
        { x: 510, y: 674 },
        { x: 488, y: 814 },
    ],
    "Jimmy Page": [
        { x: 564, y: 672 },
        { x: 577, y: 558 },
        { x: 633, y: 534 },
        { x: 662, y: 666 },
        { x: 644, y: 806 },
        { x: 588, y: 806 },
        { x: 590, y: 724 },
    ],
    "Paul McCartney": [
        { x: 292, y: 744 },
        { x: 297, y: 684 },
        { x: 416, y: 678 },
        { x: 418, y: 795 },
        { x: 404, y: 885 },
        { x: 347, y: 883 },
        { x: 350, y: 793 },
    ],
    "Eric Clapton": [
        { x: 494, y: 817 },
        { x: 512, y: 673 },
        { x: 554, y: 674 },
        { x: 583, y: 730 },
        { x: 571, y: 871 },
        { x: 519, y: 874 },
    ],
    "John Lennon": [
        { x: 667, y: 674 },
        { x: 747, y: 676 },
        { x: 760, y: 795 },
        { x: 742, y: 877 },
        { x: 688, y: 877 },
        { x: 664, y: 793 },
        { x: 658, y: 728 },
    ],
    "Ray Davies": [
        { x: 841, y: 620 },
        { x: 806, y: 619 },
        { x: 757, y: 689 },
        { x: 783, y: 831 },
        { x: 842, y: 831 },
        { x: 903, y: 710 },
        { x: 898, y: 686 },
        { x: 846, y: 670 },
    ],
    "David Bowie": [
        { x: 240, y: 733 },
        { x: 279, y: 735 },
        { x: 347, y: 793 },
        { x: 336, y: 923 },
        { x: 292, y: 939 },
        { x: 216, y: 935 },
        { x: 226, y: 790 },
    ],
    "Marc Bolan": [
        { x: 759, y: 807 },
        { x: 753, y: 853 },
        { x: 769, y: 960 },
        { x: 868, y: 967 },
        { x: 870, y: 917 },
        { x: 847, y: 837 },
        { x: 781, y: 835 },
    ],
    "Jim Morrison": [
        { x: 200, y: 936 },
        { x: 294, y: 944 },
        { x: 296, y: 1032 },
        { x: 271, y: 1157 },
        { x: 177, y: 1157 },
    ],
    "Paul Simon": [
        { x: 346, y: 890 },
        { x: 341, y: 926 },
        { x: 306, y: 943 },
        { x: 305, y: 1118 },
        { x: 408, y: 1125 },
        { x: 408, y: 933 },
        { x: 383, y: 896 },
    ],
    "Keith Richards": [
        { x: 419, y: 1035 },
        { x: 413, y: 894 },
        { x: 439, y: 820 },
        { x: 490, y: 826 },
        { x: 514, y: 885 },
        { x: 544, y: 893 },
        { x: 525, y: 1042 },
    ],
    "Van Morrison": [
        { x: 586, y: 826 },
        { x: 575, y: 874 },
        { x: 553, y: 896 },
        { x: 563, y: 1040 },
        { x: 646, y: 1039 },
        { x: 680, y: 868 },
        { x: 670, y: 833 },
    ],
    "Jerry Garcia": [
        { x: 685, y: 883 },
        { x: 747, y: 881 },
        { x: 762, y: 962 },
        { x: 789, y: 966 },
        { x: 789, y: 985 },
        { x: 745, y: 1051 },
        { x: 745, y: 1100 },
        { x: 681, y: 1104 },
        { x: 662, y: 970 },
    ],
    "Stevie Nicks": [
        { x: 756, y: 1047 },
        { x: 805, y: 969 },
        { x: 846, y: 972 },
        { x: 903, y: 1023 },
        { x: 889, y: 1163 },
        { x: 805, y: 1164 },
    ],
};